/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthenticationSchema { 
    type?: AuthenticationSchema.TypeEnum;
    name?: string;
    description?: string;
    specUri?: string;
    documentationUri?: string;
}
export namespace AuthenticationSchema {
    export type TypeEnum = 'oauth' | 'oauth2' | 'oauthbearertoken' | 'httpbasic' | 'httpdigest';
    export const TypeEnum = {
        Oauth: 'oauth' as TypeEnum,
        Oauth2: 'oauth2' as TypeEnum,
        Oauthbearertoken: 'oauthbearertoken' as TypeEnum,
        Httpbasic: 'httpbasic' as TypeEnum,
        Httpdigest: 'httpdigest' as TypeEnum
    };
}


